/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Page_BodyInputs */

const en_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong on our end.`)
};

const es_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal de nuestro lado.`)
};

const de_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei uns ist etwas schief gelaufen.`)
};

const zh_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们这边出了点问题。`)
};

const ar_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ من جهتنا.`)
};

const fr_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelque chose s'est mal passé de notre côté.`)
};

const vi_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xảy ra lỗi phía chúng tôi.`)
};

const sw_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitilafu fulani imetokea upande wetu.`)
};

const th_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีบางอย่างผิดพลาดทางฝั่งของเรา`)
};

const bs_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nešto je pošlo po zlu na našoj strani.`)
};

const ja_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終わりに何かが間違っていた。`)
};

const ko_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뭔가 우리의 끝에 잘못되었습니다.`)
};

const pt_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado do nosso lado.`)
};

const it_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è qualcosa che non va.`)
};

const sv_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Något gick fel på vårt slut.`)
};

const nl_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er ging iets mis bij ons.`)
};

const da_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noget gik galt i vores ende.`)
};

const nb_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noe gikk galt på slutten.`)
};

const fi_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokin meni pieleen.`)
};

const pl_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak.`)
};

const ru_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так с нашей стороны.`)
};

const tr_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir şey sonunda yanlış gitti.`)
};

const hi_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे अंत में कुछ गलत हो गया।`)
};

const id_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang salah di sini.`)
};

const ms_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada sesuatu yang tidak kena di pihak kami.`)
};

const cs_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Něco se pokazilo.`)
};

const el_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάτι πήγε στραβά από την πλευρά μας.`)
};

const he_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`משהו השתבש אצלנו.`)
};

const af_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iets het aan ons kant verkeerd geloop.`)
};

const hu_error_page_body = /** @type {(inputs: Error_Page_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valami balul sült el a mi oldalunkon.`)
};

/**
* | output |
* | --- |
* | "Something went wrong on our end." |
*
* @param {Error_Page_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const error_page_body = /** @type {((inputs?: Error_Page_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Page_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_page_body(inputs)
	if (locale === "de") return de_error_page_body(inputs)
	if (locale === "zh") return zh_error_page_body(inputs)
	if (locale === "ar") return ar_error_page_body(inputs)
	if (locale === "fr") return fr_error_page_body(inputs)
	if (locale === "vi") return vi_error_page_body(inputs)
	if (locale === "sw") return sw_error_page_body(inputs)
	if (locale === "th") return th_error_page_body(inputs)
	if (locale === "bs") return bs_error_page_body(inputs)
	if (locale === "ja") return ja_error_page_body(inputs)
	if (locale === "ko") return ko_error_page_body(inputs)
	if (locale === "pt") return pt_error_page_body(inputs)
	if (locale === "it") return it_error_page_body(inputs)
	if (locale === "sv") return sv_error_page_body(inputs)
	if (locale === "nl") return nl_error_page_body(inputs)
	if (locale === "da") return da_error_page_body(inputs)
	if (locale === "nb") return nb_error_page_body(inputs)
	if (locale === "fi") return fi_error_page_body(inputs)
	if (locale === "pl") return pl_error_page_body(inputs)
	if (locale === "ru") return ru_error_page_body(inputs)
	if (locale === "tr") return tr_error_page_body(inputs)
	if (locale === "hi") return hi_error_page_body(inputs)
	if (locale === "id") return id_error_page_body(inputs)
	if (locale === "ms") return ms_error_page_body(inputs)
	if (locale === "cs") return cs_error_page_body(inputs)
	if (locale === "el") return el_error_page_body(inputs)
	if (locale === "he") return he_error_page_body(inputs)
	if (locale === "af") return af_error_page_body(inputs)
	if (locale === "hu") return hu_error_page_body(inputs)
	return en_error_page_body(inputs)
});